import internalHttp from 'hubspotter-http/clients/apiHubSpotterClient';
import appAuthHttp from 'hub-http/clients/apiClient';
import { getIsHubteamSubdomain } from 'flow-doctor-lib/constants/Env';
export const getHttpClient = internal => internal ? internalHttp : appAuthHttp;
export default getHttpClient(getIsHubteamSubdomain());